import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface TourRequest {
  id?: number,
  name: string,
  price: number,
  status?: string,
}

export interface TourResponse {
  id: number,
  name: string,
  price: number,
  status: string,
}

export interface SignupResponse {
  id: number,
  name: string,
  mobile: string,
  national_num: string,
  birthday: string,
  create_date: string,
  payment_auth: string,
  payment_ref: string,
  ip: string,
  user_agent: string,
  hash: string,
  gateway_status: string,
  tour_id: number,
  city_id: number,
  site_id: number,
  status: string,
}

export const ebroApi = createApi({
  reducerPath: 'ebroApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/custom-modules/ebro',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['tour','signup'],

  endpoints: (builder) => ({
    getAllTours: builder.query<TourResponse[], void>({
      query: () => 'tour/panel/all',
      providesTags: ['tour']
    }),
    getTour: builder.query<TourResponse, number>({
      query: (id) => `tour/panel/${id}`,
    }),
    createTour: builder.mutation<boolean, TourRequest>({
      query: (data) => ({
        url: 'tour/panel',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['tour']
    }),
    updateTour: builder.mutation<TourResponse, Partial<TourRequest> & Pick<TourRequest, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `tour/panel/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['tour']
    }),
    deleteTour: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `tour/panel/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['tour']
    }),
    //signup
    getSignupByTour: builder.query<SignupResponse[], number | undefined>({
      query: (id) => `signup/panel/getBytour/${id}`,
      providesTags: ['signup']
    }),
  }),
})

export const { useGetAllToursQuery, useGetTourQuery, useLazyGetTourQuery, useCreateTourMutation, 
  useUpdateTourMutation, useDeleteTourMutation, useGetSignupByTourQuery } = ebroApi